import { richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  description[]{${richTextFields}},
  contactInfo[]{${richTextFields}},
  officeAddress[]{${richTextFields}}
`

export const fragment = (name = 'contactForm') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
